/***********************/
/* Angular + external */
import { Injectable, ViewContainerRef } from "@angular/core";
import { Observable, Subscription } from "rxjs";
/***********************/
/* BFX */
// models
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterActionEvent } from "../../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxDialogData } from "../models/bfx-dialog-data.model";
// services
import { BfxConfigService } from "../../../shared/auth-services/system-config/bfx-config.service";
import { TranslateService } from "@ngx-translate/core";
import { BfxRBACService } from "../../bfx-common/services/bfx-rbac.service";
import {
  TradeDealPromiseService,
  TraderGroupPrimaryLookupService,
  SystemConfigPromiseService,
  ClientPromiseLookupService,
  CcyPromiseLookupService,
  BranchPromiseLookupService,
  OrderDataActionPromiseService,
} from "shared/cubiq-services";
import { BfxBlotterTradeDialogActionEvent } from "app/bfx-blotter-trade/services/bfx-trade-contextmenu.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxTradeDialogsProcessorService {
  /***************************************/
  /* DATA */
  public config: any = {
    debug: false,
  };

  private configurationSubscription: Subscription;
  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(
    private _configService: BfxConfigService,
    private _translationService: TranslateService,
    private _tradeDealService: TradeDealPromiseService,
    // not in use atm
    private _rbacService: BfxRBACService,
    private _traderGroupLookupService: TraderGroupPrimaryLookupService,
    private _clientLookupService: ClientPromiseLookupService,
    private _ccyLookupService: CcyPromiseLookupService,
    private _branchLookupService: BranchPromiseLookupService,
    private _orderDataActionService: OrderDataActionPromiseService,
    private _systemConfigService: SystemConfigPromiseService,
  ) {
    this.subscribeToConfiguration();
  }

  /**********************************************************************/
  /* INITIALIZATION */
  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config = config.general;
    });
  }
  /**********************************************************************/
  /* CANCEL TRADE */
  public executeCancelTrade(event: BfxBlotterTradeDialogActionEvent): Promise<any> {
    return new Promise((resolve, reject) => {
      this._tradeDealService.cancelTradeDeals(event.selectedTradeDeals).then(
        (response) => {
          logger.out.info(
            "INFO: BfxTradeDialogsProcessorService.executeCancelTrade(): response=",
            response,
          );
          if (response !== true) {
            if (response.results != null && response.results.length > 0) {
              for (let result of response.results) {
                if (
                  result.errors != null &&
                  result.errors.errorMessages != null &&
                  result.errors.errorMessages.length > 0
                ) {
                  // let errors: CubiqTS.ErrorsImpl = result.errors as CubiqTS.ErrorsImpl;
                  try {
                    let msg: string = this.handleErrors(result.errors.errorMessages); // errors.errorMessages[0].toString();
                    logger.out.error("FLAG TRADE AS CANCELLED - FAIL", "ERROR: " + msg);
                  } catch (ex) {
                    logger.out.error(
                      "FLAG TRADE AS CANCELLED - FAIL",
                      "ERROR: " + result.errors.errorMessages[0].toString(),
                    );
                  }
                }
              }
            }
          }
          resolve(response);
        },
        (rej) => {
          logger.out.error(
            "ERROR: BfxTradeDialogsProcessorService.executeCancelTrade(): rejected =",
            rej,
          );
          reject(rej);
        },
      );
    });
  }

  /**********************************************************************/
  /* ADD FILL COMMENT */

  public executeAddFillComment(
    _event: BfxBlotterTradeDialogActionEvent,
    _fillComment: string,
  ): Promise<any> {
    // logger.out.info("OMS BfxTradeActionsService: executeAddFillComment(): event= ", _event, " comment= ", _fillComment);
    return new Promise((resolve, reject) => {
      if (_event && _event.selectedTradeDeals[0]) {
        let tradeDeal = _event.selectedTradeDeals[0];
        this._tradeDealService.addFillComment(tradeDeal, _fillComment).then(
          (response) => {
            logger.out.info(
              "INFO: BfxTradeDialogsProcessorService.executeAddFillComment(): id=" +
                tradeDeal +
                " response=",
              response,
            );
            if (response !== true) {
              /* if(response.results != null && response.results.length > 0){
								for(let result of response.results ){
									if(result.errors != null && result.errors.errorMessages != null && result.errors.errorMessages.length > 0){ */

              try {
                let error = JSON.parse(response);
                let msg: string = this._translationService.instant(error["id"], error["args"]);
                logger.out.error("ADD FILL COMMENT - FAIL", "ERROR: " + msg);
              } catch (ex) {
                logger.out.error(
                  "ADD FILL COMMENT - FAIL",
                  "ERROR: " + response.toString(),
                  "short",
                );
              }
              /* 		}
								}
							} */
            }
            resolve(response);
          },
          (rej) => {
            logger.out.error(
              "OMS BfxTradeActionsService.executeAddFillComment(): Action rejected=",
              rej,
            );
            reject(rej);
          },
        );
      } else {
        logger.out.error(
          "ERROR: BfxTradeActionsService.executeAddFillComment(): TradeDeal in event not valid!",
        );
        resolve(false);
      }
    });
  }

  /**********************************************************************/
  /* Helpers */
  private handleErrors(errors: any[]): string {
    let message = "";
    errors
      .map((e) => JSON.parse(e))
      .forEach((e) => (message += this._translationService.instant(e["id"], e["args"]) + "\n"));
    return message;
  }
}
